'use client';

import { Input } from '@/components/Input';
import { Select } from '@/components/Select';
import { cards } from './card-data';
import { OssCard } from './oss-card';
import { useState } from 'react';

const SORT_OPTIONS = {
  A_Z: 'a-z',
  Z_A: 'z-a',
};

const sortOptions = [
  { label: 'A-Z', value: SORT_OPTIONS.A_Z },
  { label: 'Z-A', value: SORT_OPTIONS.Z_A },
];

export function OSSCards() {
  const [search, setSearch] = useState('');
  const [sort, setSort] = useState('');

  const filteredCards = cards.filter(card => card.name.toLowerCase().includes(search.toLowerCase()));

  const sortedCards = filteredCards.sort((a, b) => {
    switch (sort) {
      case SORT_OPTIONS.A_Z:
        return a.name.localeCompare(b.name);
      case SORT_OPTIONS.Z_A:
        return b.name.localeCompare(a.name);
      default:
        return 0;
    }
  });

  // Show all cards count, not just the sorted ones
  const numberOfCards = cards.length;

  return (
    <section className="py-section px-section bg-gray-1 text-gray-4">
      <div className="max-w-section">
        <div className="mb-6 grid grid-cols-2 grid-rows-2 items-center gap-6 md:grid-cols-[1fr_320px_auto] md:grid-rows-1">
          <div className="">
            {numberOfCards} OSS Project{numberOfCards > 1 ? 's' : ''}
          </div>
          <div className="order-0 w-[150px] justify-self-end md:order-2">
            <Select
              placeholder="Sort by"
              options={sortOptions}
              value={sort}
              onChange={e => setSort(e.target.value)}
              selectClassName="bg-[#13171B] text-gray-4 border-[#2B2B2B] border rounded-md]"
            />
          </div>
          <div className="col-span-2 md:col-span-1">
            <Input
              name="search"
              placeholder="Search OSS Projects"
              className="w-full rounded-md border border-[#2B2B2B] bg-[#13171B] text-gray-4"
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
          </div>
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          {sortedCards.map((card, index) => (
            <OssCard key={index} card={card} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
}
